import React from "react";
import { useTranslation } from "react-i18next";
import { LockIcon } from "@/apps/raffle/pages/RafflePage/icons";
import {
  CENTER,
  createSectorPath,
  HORIZONTAL_SAFE_GAP,
  RIM_WIDTH,
  WHITE_RIM_WIDTH,
  WHEEL_SIZE,
} from "./wheelMath";
import cls from "./styles.module.scss";

const LOCKED_WHEEL_SCALE = 0.6;
const LOCKED_SECTORS_COUNT = 20;

export const LockedRaffleWheel = () => {
  const { t } = useTranslation();
  const baseViewportScale =
    typeof window === "undefined"
      ? 1
      : Math.min(1, (window.innerWidth - HORIZONTAL_SAFE_GAP) / WHEEL_SIZE);
  const wheelSize = WHEEL_SIZE * baseViewportScale * LOCKED_WHEEL_SCALE;
  const sectorAngle = 360 / LOCKED_SECTORS_COUNT;
  const center = CENTER;
  const radius = CENTER - RIM_WIDTH - WHITE_RIM_WIDTH;

  return (
    <div
      className={cls.lockedWheel}
      style={{ width: `${wheelSize}px` }}
      aria-label={t("raffle.a11y.lockedWheel")}
    >
      <svg
        className={cls.svg}
        width={wheelSize}
        height={wheelSize}
        viewBox={`0 0 ${WHEEL_SIZE} ${WHEEL_SIZE}`}
        role="img"
      >
        {Array.from({ length: LOCKED_SECTORS_COUNT }, (_, index) => (
          <path
            key={index}
            className={
              [cls.greenSector, cls.redSector, cls.goldSector][index % 3]
            }
            d={createSectorPath(
              index * sectorAngle,
              (index + 1) * sectorAngle,
              radius,
              center
            )}
            opacity="0.72"
          />
        ))}
        <circle
          cx={center}
          cy={center}
          r={center - RIM_WIDTH / 2}
          fill="none"
          stroke="var(--palette-red-500)"
          strokeWidth={RIM_WIDTH}
        />
        <circle
          cx={center}
          cy={center}
          r={center - RIM_WIDTH - WHITE_RIM_WIDTH / 2}
          fill="none"
          stroke="var(--palette-white)"
          strokeWidth={WHITE_RIM_WIDTH}
        />
      </svg>
      <span className={cls.lockedWheelCenter}>
        <LockIcon />
      </span>
    </div>
  );
};
